

//bss fix 
document.addEventListener("DOMContentLoaded", e => {
  BSS_B2B.customTriggerCheckoutBtn = function(){
    window.location.href = '/checkout';
  }
});

window.addEventListener("semanticInput", e => {
  BSS_B2B.cart?.fixer(BSS_B2B.shopData,0,0)
});


(() => {
  if(window.location.pathname === '/apps/customer-portal/purchase-late') {
    let counter = 0;
    let selector = "#AppFrameMain > div > div > div.bss-layout-content-wrapper > div:nth-child(3) > div > div > div.bss-nt-layout-info > div > div.Polaris-LegacyCard__Header > h2";
    const interval = setInterval(() => {
        if ($(selector).length > 0) {
            const title = $(selector);
            title.html(title.html().replace(/amp;/g, '&'));
            clearInterval(interval);
        } else {
            counter += 100;
            if (counter >= 10000) {
                clearInterval(interval);
            }
        }
    }, 100);
    
  }
})()

//change quantity cart visible nt btn
if(typeof BSS_BCP !== undefined && window.location.pathname === '/cart'){
  setTimeout(()=>{
      const elm = document.querySelector("#shopify-section-template--20420549640473__main-cart");
    if(elm){
        const observer = new MutationObserver((MutationList)=>{
          for(let mutation of MutationList){
            if(mutation.target.id === "shopify-section-template--20420549640473__main-cart"){
              BSS_BCP.netterm?.showButtonOnCartPage?.();
              break;
            }
          }
        })
      observer.observe(elm, {childList: true, subtree: true})
      }
    },200)
}

//fix rf
if(typeof BSS_B2B !== undefined && window.location.pathname === '/account/register'){
  setTimeout(()=>{
    const register_form = document.querySelector("#bss-b2b-registration-form-render");
    const submit_btn = document.querySelector(`form[action="/account"]:has([bss-b2b-is-email-field]) p.submit`);
    if(register_form && submit_btn){
      submit_btn.before(register_form)
    }

    const field_elm = document.querySelectorAll(".rendered-form .formbuilder-text");
    if(field_elm.length){
      field_elm.forEach(item => {
        const input = item.querySelector("input");
        const label = item.querySelector("label");
        if(input && label){
          input.placeholder = label.textContent.replace(/\*/g, '');
        }
      })
    }
  }, 100)
}


//fix cp
if(typeof BSS_B2B !== undefined){
 setTimeout(() => {
   const quickshop = document.querySelector("#quickshop");
   if(quickshop){
     const observer = new MutationObserver(()=>{
       try{
      BSS_B2B.cp.changeProductPrice(JSON.parse($("#bss-b2b-store-data").html()), false, false)
       }catch(e){}
     })
     observer.observe(quickshop, {attributes: true})
   }
 },500)
}
// fix QI
if(typeof BSS_B2B !== undefined && window.location.pathname.includes("/products")){
  setTimeout(() => {
    BSS_B2B.qi.handleSetupQuantity();
  }, 3000);
}

if(typeof BSS_B2B !== undefined && window.location.pathname.includes('/account/register')){
setTimeout(() => {
    var countryNames = {
  "Afghanistan": "Afghanistan",
  "Albania": "Albanië",
  "Algeria": "Algerije",
  "Andorra": "Andorra",
  "Angola": "Angola",
  "Antigua & Barbuda": "Antigua en Barbuda",
  "Argentina": "Argentinië",
  "Armenia": "Armenië",
  "Australia": "Australië",
  "Austria": "Oostenrijk",
  "Azerbaijan": "Azerbeidzjan",
  "Bahamas": "Bahama's",
  "Bahrain": "Bahrein",
  "Bangladesh": "Bangladesh",
  "Barbados": "Barbados",
  "Belarus": "Wit-Rusland",
  "Belgium": "België",
  "Belize": "Belize",
  "Benin": "Benin",
  "Bermuda": "Bermuda",
  "Bhutan": "Bhutan",
  "Bolivia": "Bolivia",
  "Bosnia & Herzegovina": "Bosnië en Herzegovina",
  "Botswana": "Botswana",
  "Brazil": "Brazilië",
  "Brunei": "Brunei",
  "Bulgaria": "Bulgarije",
  "Burkina Faso": "Burkina Faso",
  "Burundi": "Burundi",
  "Cambodia": "Cambodja",
  "Cameroon": "Kameroen",
  "Canada": "Canada",
  "Cape Verde": "Kaapverdië",
  "Central African Republic": "Centraal-Afrikaanse Republiek",
  "Chad": "Tsjaad",
  "Chile": "Chili",
  "China": "China",
  "Colombia": "Colombia",
  "Comoros": "Comoren",
  "Congo - Brazzaville": "Congo - Brazzaville",
  "Congo - Kinshasa": "Congo - Kinshasa",
  "Cook Islands": "Cookeilanden",
  "Costa Rica": "Costa Rica",
  "Croatia": "Kroatië",
  "Cuba": "Cuba",
  "Cyprus": "Cyprus",
  "Czechia": "Tsjechië",
  "Denmark": "Denemarken",
  "Djibouti": "Djibouti",
  "Dominica": "Dominica",
  "Dominican Republic": "Dominicaanse Republiek",
  "Ecuador": "Ecuador",
  "Egypt": "Egypte",
  "El Salvador": "El Salvador",
  "Equatorial Guinea": "Equatoriaal-Guinea",
  "Eritrea": "Eritrea",
  "Estonia": "Estland",
  "Eswatini": "Eswatini",
  "Ethiopia": "Ethiopië",
  "Fiji": "Fiji",
  "Finland": "Finland",
  "France": "Frankrijk",
  "Gabon": "Gabon",
  "Gambia": "Gambia",
  "Georgia": "Georgië",
  "Germany": "Duitsland",
  "Ghana": "Ghana",
  "Greece": "Griekenland",
  "Grenada": "Grenada",
  "Guatemala": "Guatemala",
  "Guinea": "Guinee",
  "Guinea-Bissau": "Guinee-Bissau",
  "Guyana": "Guyana",
  "Haiti": "Haïti",
  "Honduras": "Honduras",
  "Hungary": "Hongarije",
  "Iceland": "IJsland",
  "India": "India",
  "Indonesia": "Indonesië",
  "Iran": "Iran",
  "Iraq": "Irak",
  "Ireland": "Ierland",
  "Israel": "Israël",
  "Italy": "Italië",
  "Jamaica": "Jamaica",
  "Japan": "Japan",
  "Jordan": "Jordanië",
  "Kazakhstan": "Kazachstan",
  "Kenya": "Kenia",
  "Kiribati": "Kiribati",
  "Kuwait": "Koeweit",
  "Kyrgyzstan": "Kirgizië",
  "Laos": "Laos",
  "Latvia": "Letland",
  "Lebanon": "Libanon",
  "Lesotho": "Lesotho",
  "Liberia": "Liberia",
  "Libya": "Libië",
  "Liechtenstein": "Liechtenstein",
  "Lithuania": "Litouwen",
  "Luxembourg": "Luxemburg",
  "Madagascar": "Madagaskar",
  "Malawi": "Malawi",
  "Malaysia": "Maleisië",
  "Maldives": "Maldiven",
  "Mali": "Mali",
  "Malta": "Malta",
  "Marshall Islands": "Marshalleilanden",
  "Martinique": "Martinique",
  "Mauritania": "Mauritanië",
  "Mauritius": "Mauritius",
  "Mexico": "Mexico",
  "Micronesia": "Micronesië",
  "Moldova": "Moldavië",
  "Monaco": "Monaco",
  "Mongolia": "Mongolië",
  "Montenegro": "Montenegro",
  "Montserrat": "Montserrat",
  "Morocco": "Marokko",
  "Mozambique": "Mozambique",
  "Myanmar (Burma)": "Myanmar (Birma)",
  "Namibia": "Namibië",
  "Nauru": "Nauru",
  "Nepal": "Nepal",
  "Netherlands": "Nederland",
  "New Caledonia": "Nieuw-Caledonië",
  "New Zealand": "Nieuw-Zeeland",
  "Nicaragua": "Nicaragua",
  "Niger": "Niger",
  "Nigeria": "Nigeria",
  "Niue": "Niue",
  "Norfolk Island": "Norfolk",
  "North Korea": "Noord-Korea",
  "North Macedonia": "Noord-Macedonië",
  "Norway": "Noorwegen",
  "Oman": "Oman",
  "Pakistan": "Pakistan",
  "Palau": "Palau",
  "Palestinian Territories": "Palestijnse gebieden",
  "Panama": "Panama",
  "Papua New Guinea": "Papoea-Nieuw-Guinea",
  "Paraguay": "Paraguay",
  "Peru": "Peru",
  "Philippines": "Filipijnen",
  "Pitcairn Islands": "Pitcairneilanden",
  "Poland": "Polen",
  "Portugal": "Portugal",
  "Puerto Rico": "Puerto Rico",
  "Qatar": "Qatar",
  "Réunion": "Réunion",
  "Romania": "Roemenië",
  "Russia": "Rusland",
  "Rwanda": "Rwanda",
  "Samoa": "Samoa",
  "San Marino": "San Marino",
  "São Tomé & Príncipe": "São Tomé en Príncipe",
  "Saudi Arabia": "Saoedi-Arabië",
  "Senegal": "Senegal",
  "Serbia": "Servië",
  "Seychelles": "Seychellen",
  "Sierra Leone": "Sierra Leone",
  "Singapore": "Singapore",
  "Sint Maarten": "Sint Maarten",
  "Slovakia": "Slowakije",
  "Slovenia": "Slovenië",
  "Solomon Islands": "Salomonseilanden",
  "Somalia": "Somalië",
  "South Africa": "Zuid-Afrika",
  "South Georgia & South Sandwich Islands": "Zuid-Georgia en Zuidelijke Sandwicheilanden",
  "South Korea": "Zuid-Korea",
  "South Sudan": "Zuid-Soedan",
  "Spain": "Spanje",
  "Sri Lanka": "Sri Lanka",
  "St. Barthélemy": "Saint-Barthélemy",
  "St. Helena": "Sint-Helena",
  "St. Kitts & Nevis": "Saint Kitts en Nevis",
  "St. Lucia": "Saint Lucia",
  "St. Martin": "Saint-Martin",
  "St. Pierre & Miquelon": "Saint-Pierre en Miquelon",
  "St. Vincent & Grenadines": "Saint Vincent en de Grenadines",
  "Sudan": "Soedan",
  "Suriname": "Suriname",
  "Svalbard & Jan Mayen": "Spitsbergen en Jan Mayen",
  "Sweden": "Zweden",
  "Switzerland": "Zwitserland",
  "Syria": "Syrië",
  "Taiwan": "Taiwan",
  "Tajikistan": "Tadzjikistan",
  "Tanzania": "Tanzania",
  "Thailand": "Thailand",
  "Timor-Leste": "Oost-Timor",
  "Togo": "Togo",
  "Tokelau": "Tokelau",
  "Tonga": "Tonga",
  "Trinidad & Tobago": "Trinidad en Tobago",
  "Tunisia": "Tunesië",
  "Turkey": "Turkije",
  "Turkmenistan": "Turkmenistan",
  "Turks & Caicos Islands": "Turks- en Caicoseilanden",
  "Tuvalu": "Tuvalu",
  "U.S. Outlying Islands": "Amerikaanse afgelegen eilanden",
  "Uganda": "Oeganda",
  "Ukraine": "Oekraïne",
  "United Arab Emirates": "Verenigde Arabische Emiraten",
  "United Kingdom": "Verenigd Koninkrijk",
  "United States": "Verenigde Staten",
  "Uruguay": "Uruguay",
  "Uzbekistan": "Oezbekistan",
  "Vanuatu": "Vanuatu",
  "Vatican City": "Vaticaanstad",
  "Venezuela": "Venezuela",
  "Vietnam": "Vietnam",
  "Wallis & Futuna": "Wallis en Futuna",
  "Western Sahara": "Westelijke Sahara",
  "Yemen": "Jemen",
  "Zambia": "Zambia",
  "Zimbabwe": "Zimbabwe"
};
  var countryListItems = document.querySelectorAll("#country-field-list li");

countryListItems.forEach(function(item) {
  var countryName = item.textContent.trim();
  var dutchName = countryNames[countryName];
  if (dutchName) {
    item.textContent = dutchName;
  }
});
}, 500)
}
//bss end
